import { RefObject, useEffect, useState } from "react"
import { getElementLineHeight } from "utils/helpers"

const useElementCountLines = (targetRef: RefObject<HTMLElement> | null) => {
  const [numberOfLines, setNumberOfLines] = useState<number | null>(null);

  useEffect(() => {
    const current = targetRef?.current
    if(!current) return;

    const countLines = () => {
      const { height } = current.getBoundingClientRect();
      const lineHeight = getElementLineHeight(current);

      setNumberOfLines(Math.trunc(height / lineHeight));
    };

    countLines();
  }, []);

  return numberOfLines
}

export default useElementCountLines
